import React from 'react';
import { Box, Typography, Grid, Button, Paper } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Link as RouterLink } from 'react-router-dom';
import { CheckCircleOutline, TrackChanges, History, RateReview } from '@mui/icons-material';
import { 
  PRIVATE_IMPROVEMENT_PROPOSAL_APPROVAL, 
  PRIVATE_IMPROVEMENT_PROPOSAL_TRACKING, 
  PRIVATE_IMPROVEMENT_PROPOSAL_HISTORY 
} from 'ImprovementProposal/Application/Constants/PathsConstant';
import { IMPROVEMENT_PROPOSAL } from 'User/Application/Constants/PathsConstant';

export default function ImprovementChannelLandingView() {
  // Apilar en una columna cuando el viewport sea <= 1000px
  const isStack = useMediaQuery('(max-width:1000px)');
  const actions = [
    {
      title: 'Aceptación / Rechazo',
      to: PRIVATE_IMPROVEMENT_PROPOSAL_APPROVAL,
      icon: <CheckCircleOutline />,
      color: 'success',
      description: 'Revisa propuestas pendientes y apruébalas o recházalas.'
    },
    {
      title: 'Seguimiento mejoras',
      to: PRIVATE_IMPROVEMENT_PROPOSAL_TRACKING,
      icon: <TrackChanges />,
      color: 'primary',
      description: 'Gestiona reuniones, actas, rechaza o cierra mejoras en curso.'
    },
    {
      title: 'Histórico mejoras',
      to: PRIVATE_IMPROVEMENT_PROPOSAL_HISTORY,
      icon: <History />,
      color: 'info',
      description: 'Consulta el histórico de mejoras cerradas y rechazadas.'
    },
    {
      title: 'Nueva propuesta',
      to: `${IMPROVEMENT_PROPOSAL}/new`,
      icon: <RateReview />,
      color: 'secondary',
      description: 'Crea una nueva propuesta de mejora con adjuntos.'
    }
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" mb={1}>Canal de mejora</Typography>
      <Typography variant="body1" color="text.secondary" mb={3}>
        Selecciona una acción para continuar.
      </Typography>
  <Grid container spacing={isStack ? 7 : 2}>
        {actions.map((a) => (
      <Grid item xs={12} sm={isStack ? 12 : 6} md={isStack ? 12 : 3} key={a.title}>
            <Paper elevation={2} sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <Box display="flex" alignItems="center" gap={1} mb={1}>
                {a.icon}
                <Typography variant="h6">{a.title}</Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" mb={2}>{a.description}</Typography>
              <Button 
                variant="contained" 
                color={a.color}
                component={RouterLink}
                to={a.to}
        fullWidth={isStack}
              >
                Ir
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
